import { ClientConstantsCacheDatasource } from "../datasources/cached/client-constants-cached.datasource";
import type { IClientConstantCachedDatasource } from "../datasources/cached/client-constants-cached.datasource.interface";
import { ClientConstantsRemoteDatasource } from "../datasources/remote/client-constants-remote.datasource";
import type { IClientConstantsRemoteDatasource } from "../datasources/remote/client-constants-remote.datasource.interface";
import type { ClientConstantCmsDto } from "../dtos/client-constant.dto";
import type { IClientConstantsRepository } from "./client-constants.repository.interface";

export class ClientConstantsRepository implements IClientConstantsRepository {
  constructor(
    private readonly _remoteCmsDataSource: IClientConstantsRemoteDatasource = new ClientConstantsRemoteDatasource(),
    private readonly _cachedCmsDataSource: IClientConstantCachedDatasource = new ClientConstantsCacheDatasource()
  ) {}

  async fetchAllClientConstantsFromRemote(): Promise<void> {
    const response = await this._remoteCmsDataSource.getAllClientConstants();
    this._cachedCmsDataSource.populateClientConstantsCache(response);
  }

  getValueFromCache(constantKey: string): ClientConstantCmsDto | undefined {
    return this._cachedCmsDataSource.getClientConstantValue(constantKey);
  }
}
